import { __awaiter, __decorate, __param } from 'tslib';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BaseService, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { ConfigService, SpeNAccountCodeProxy, UiPxTokenModule } from '@wlp/ui-px-token';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let TokenCodeService = class TokenCodeService extends BaseService {
    constructor(storage, configService, errorMessageService, speNAccountCodeProxy, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.speNAccountCodeProxy = speNAccountCodeProxy;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            token: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'invalid', message: 'Código inválido' },
            ],
        };
    }
    createFormToken() {
        this.formToken = this.formBuilder.group({
            token: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formToken;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    getToken(uuidWhiteLabel, uuidAccountPayment) {
        return this.speNAccountCodeProxy.getCode(uuidWhiteLabel, uuidAccountPayment);
    }
    getTokenSms(uuidWhiteLabel, uuidAccountPayment, userId) {
        return this.speNAccountCodeProxy.getCodeSms(uuidWhiteLabel, uuidAccountPayment, userId);
    }
    getTokenSmsUser(payload) {
        return this.speNAccountCodeProxy.getCodeSmsUser(payload);
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    checkCode(uuidWhiteLabel, uuidAccountPayment, code, userId) {
        return this.speNAccountCodeProxy.checkCode(uuidWhiteLabel, uuidAccountPayment, code, userId);
    }
    confirmToken(uuidWhiteLabel, uuidAccount, token, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            let isValid;
            yield this.checkCode(uuidWhiteLabel, uuidAccount, token, userId)
                .toPromise()
                .then(res => {
                isValid = res.validCode;
            })
                .catch(err => this.getErroMessage(err));
            let response = !!isValid ? isValid : false;
            return Promise.resolve(response);
        });
    }
    confirmTokenUser(token) {
        return __awaiter(this, void 0, void 0, function* () {
            let isValid;
            yield this.speNAccountCodeProxy.checkCodeUser(token)
                .toPromise()
                .then(res => {
                isValid = res.validCode;
            })
                .catch(err => this.getErroMessage(err));
            let response = !!isValid ? isValid : false;
            return Promise.resolve(response);
        });
    }
    getCodeMethodPreference() {
        return this.speNAccountCodeProxy.getCodeMethodPreference();
    }
    defineCodeMethodPreference(data) {
        return this.speNAccountCodeProxy.defineCodeMethodPreference(data);
    }
    newSendCode(data) {
        return this.speNAccountCodeProxy.newSendCode(data);
    }
    deleteBiometric(uuidBioauth, body = []) {
        return this.speNAccountCodeProxy.deleteBiometric(uuidBioauth, body);
    }
    startInformation(devicePlatform, deviceModel, deviceManufacturer, deviceSerial) {
        return this.speNAccountCodeProxy.startInformation(devicePlatform, deviceModel, deviceManufacturer, deviceSerial);
    }
    hasBiometric(devicePlatform, deviceModel, deviceManufacturer, deviceSerial) {
        return this.speNAccountCodeProxy.hasBiometric(devicePlatform, deviceModel, deviceManufacturer, deviceSerial);
    }
    //valida o código várias vezes até que seja válido
    validateCode(data) {
        return this.speNAccountCodeProxy.validateCode(data);
    }
    //válida o código apenas 1 vez, se digitar errado terá que gerar outro
    consumeCode(data) {
        return this.speNAccountCodeProxy.consumeCode(data);
    }
};
TokenCodeService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: SpeNAccountCodeProxy },
    { type: FormBuilder }
];
TokenCodeService = __decorate([
    Injectable()
], TokenCodeService);

var UiBsTokenModule_1;
let UiBsTokenModule = UiBsTokenModule_1 = class UiBsTokenModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsTokenModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsTokenModule.ctorParameters = () => [
    { type: UiBsTokenModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsTokenModule = UiBsTokenModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            IonicModule,
            UiBsUtilModule,
            UiPxTokenModule
        ],
        providers: [TokenCodeService],
        exports: []
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsTokenModule);

class TokenCodeResponse {
}

class CheckCodeResponse {
}

/*
 * Public API Surface of ui-bs-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CheckCodeResponse, TokenCodeResponse, TokenCodeService, UiBsTokenModule };
//# sourceMappingURL=wlp-ui-bs-token.js.map
